import {Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";
import {Directive, Input} from "@angular/core"

@Directive({
  selector:'[minValue]',
  providers:[
    {
      provide:NG_VALIDATORS,
      useExisting:MinValue,
      multi:true
    }
  ]
})
export class MinValue implements Validator{
    @Input() minValue:string
    validate(control:AbstractControl):null|{[key:string]:any}{
      const value=control.value
      if(value<this.minValue)
        return {'minValueError':true,'allowedMinValue':this.minValue}
      return null
    }
}


